module.exports = __webpack_public_path__ + "static/media/creative.9f22e533.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/creative.png
// module id = 402
// module chunks = 1